export default __webpack_public_path__ + "static/media/TERRASSE 104 CLICHY (43 sur 53).52d171b6.jpg";